import React, { useState, useEffect } from "react";
import SelectDropdown from "../../../../../components/dropdown/selectdropdown/SelectDropdown";
import BasicCard from "../../../../../components/card/basiccard/BasicCard";
import importSectionStyles from "../../../ImportSection.styles";
import { useDispatch, useSelector } from "react-redux";
import { componentKey } from "./ExcelImportSlice";
import qbdStyles from "../Qbd.styles";
import useGarbageCollector from "../../../../../../libs/garbagecollector/garbageCollectorHooks";
import { getFormAndTaxYearList, getFormSetting, getLoadImportData, getPayersList } from "./ExcelImportSaga";
import FormAttachmentUpload from "../../../../components/formattachmentupload.js/FormAttachmentUpload";
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { FORM_IDS, INTEGRATION_CONSTANTS, INTEGRATION_LOADING_STATES, QBD_LOADING_STATES, QBD_LOADING_STATES_MESSAGE_MAP, SOURCE_CONSTANTS } from "../../constants";
import ImportDataGridView from "../../../../components/importdatagridview/ImportDataGridView";
import Breadcrumbs from "../../../../../components/breadcrumbs/Breadcrumbs";
import { INTEGRATION_ROUTES } from "../../../../constants/constants";
import Loadable from "../../../../../components/loadable/Loadable";

export default function ExcelImport() {

    useGarbageCollector(componentKey);

    const [taxYearOptions, setTaxYearOptions] = useState([]);
    const [formOptions, setFormOptions] = useState([]);
    const [selectedTaxYear, setSelectedTaxYear] = useState("");
    const [selectedPayer, setSelectedPayer] = useState({});
    const [selectedFormName, setSelectedFormName] = useState("");
    const [attachments, setAttachments] = useState([]);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const dispatch = useDispatch();
    const { loadingState, formAndTaxYearList, payersList, importData, formSettings, isImportDataGridViewLoaded } = useSelector(state => state[componentKey]);

    useEffect(() => {
        if (attachments.length === 2) {
            setIsFileUploaded(true);
        }
        else {
            setIsFileUploaded(false);
        }
    }, [attachments])

    const handleNextButtonClick = () => {
        if (selectedFormName && selectedPayer.value && selectedTaxYear && attachments[0]?.FilePath && attachments[1]?.FilePath) {
            dispatch(getLoadImportData(
                {
                    integrationImportRequestDto: {
                        TaxYear: selectedTaxYear,
                        FormName: selectedFormName,
                        BusinessId: selectedPayer.value,
                        uploadedFilePath: attachments[0]?.FilePath,
                        UploadedFilePath2: attachments[1]?.FilePath,
                        Source: SOURCE_CONSTANTS.QBD_EXCELIMPORT_SOURCE
                    }
                }));
        }
        else {
            dispatch(addNotifications({
                heading: "Required fields missing",
                message: "Please choose tax year , form type and Payer to proceed"
            }));
        }
    };

    const handleAttachmentsChange = (newAttachment) => {
        if (attachments.length < 2) {
            setAttachments([...attachments, newAttachment]);
        }
    };

    const handleRemoveAttachment = (index) => {
        const updatedAttachments = attachments.filter((_, i) => i !== index);
        setAttachments(updatedAttachments);
    };

    useEffect(() => {
        dispatch(getFormAndTaxYearList());
        if (payersList.length === 0) {
            dispatch(getPayersList());
        }
    }, []);

    useEffect(() => {
        if (formAndTaxYearList) {
            setTaxYearOptions(formAndTaxYearList.TaxYear);
            setFormOptions(formAndTaxYearList.FormType);
        }
    }, [formAndTaxYearList]);

    useEffect(() => {
        if (importData) {
            dispatch(getFormSetting({ formId: selectedFormName, year: selectedTaxYear }));
        }
    }, [importData]);

    const breadcrumbItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'qbd', link: `/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.QBD}` },
        { text: 'excelimport', link: `/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.EXCEL_IMPORT}` },
    ];

    return (
        <>
            <Breadcrumbs items={breadcrumbItems} />
            {(formSettings && selectedTaxYear && selectedFormName && isImportDataGridViewLoaded) ? (

                <ImportDataGridView
                    isStateFilingApplicable={false}
                    filingForCorrected={false}
                    formSettings={formSettings}
                    formName={selectedFormName}
                    formId={
                        (() => {
                            switch (selectedFormName) {
                                case INTEGRATION_CONSTANTS.NEC_FORM:
                                    return FORM_IDS.$1099NEC;
                                case INTEGRATION_CONSTANTS.MISC_FORM:
                                    return FORM_IDS.$1099MISC;
                                default:
                                    return null;
                            }
                        })()
                    }
                    taxYear={selectedTaxYear}
                />
            ) : (
                <>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={QBD_LOADING_STATES.PAGE_LOADING}
                        messageMap={QBD_LOADING_STATES_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        <div style={importSectionStyles.title}>
                            <strong>Bulk Import : 1099 QuickBooks Desktop Excel Import</strong>
                        </div>
                        <div style={qbdStyles.container}>
                            <div style={qbdStyles.cardContainer}>
                                <BasicCard customStyles={qbdStyles.card}>
                                    <strong style={importSectionStyles.title}>Select Your QBD Excel Import File Information</strong>
                                    <div style={qbdStyles.dropdownContainer}>
                                        <Loadable
                                            currentState={loadingState.state}
                                            loadingStates={QBD_LOADING_STATES.DROPDOWNS_LOADING}
                                            messageMap={QBD_LOADING_STATES_MESSAGE_MAP}
                                            isNewLoadable={true}
                                        >
                                            <SelectDropdown
                                                label="Form Name"
                                                name="formName"
                                                value={{ label: selectedFormName || '', value: selectedFormName || '' }}
                                                options={formOptions}
                                                onSelectCb={(name, selectedOption) => setSelectedFormName(selectedOption.value)}
                                                dropdownMenuStyle={qbdStyles.dropdownWidth}
                                                dropdownContainerStyles={qbdStyles.dropdownWidth}
                                                customStyles={qbdStyles.dropdown}
                                            />
                                            <SelectDropdown
                                                label="Tax Year"
                                                name="taxYear"
                                                value={{ label: selectedTaxYear || '', value: selectedTaxYear || '' }}
                                                options={taxYearOptions}
                                                onSelectCb={(name, selectedOption) => setSelectedTaxYear(selectedOption.value)}
                                                dropdownMenuStyle={qbdStyles.dropdownWidth}
                                                dropdownContainerStyles={qbdStyles.dropdownWidth}
                                                customStyles={qbdStyles.dropdown}
                                            />
                                        </Loadable>
                                        <Loadable
                                            currentState={loadingState.state}
                                            loadingStates={QBD_LOADING_STATES.DROPDOWNS_LOADING}
                                            messageMap={QBD_LOADING_STATES_MESSAGE_MAP}
                                            isNewLoadable={true}
                                        >
                                            <SelectDropdown
                                                label="Select Payer"
                                                name="selectPayer"
                                                value={{ label: selectedPayer.label || '', value: selectedPayer.value || '' }}
                                                options={payersList}
                                                onSelectCb={(name, selectedOption) => setSelectedPayer(selectedOption)}
                                                dropdownMenuStyle={qbdStyles.dropdownWidth}
                                                dropdownContainerStyles={qbdStyles.dropdownWidth}
                                                customStyles={qbdStyles.dropdown}
                                            />
                                        </Loadable>
                                    </div>
                                </BasicCard>
                            </div>
                            <div style={qbdStyles.cardContainer}>
                                <BasicCard customStyles={qbdStyles.uploadCard}>
                                    <strong style={importSectionStyles.title}>Upload Vendor and Summary Files Here</strong>
                                    <div style={qbdStyles.uploadContainer}>
                                        {attachments.map((attachment, index) => (
                                            <div key={index} style={qbdStyles.attachmentItem}>
                                                <span style={qbdStyles.fileName}>{attachment.FileName}</span>
                                                {attachments.length === index + 1 &&
                                                    <Button
                                                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                                        style={qbdStyles.removeButton}
                                                        onClickCb={() => handleRemoveAttachment(index)}
                                                    >
                                                        Remove
                                                    </Button>
                                                }
                                            </div>
                                        ))}
                                        {attachments.length < 2 && (
                                            <FormAttachmentUpload
                                                onChangeCb={handleAttachmentsChange}
                                                value={attachments[attachments.length - 1]}
                                                name={
                                                    attachments.length === 0 ? 'Vendor Contact Report File' : 'Vendor Summary Report File'
                                                }
                                                allowedFileTypes={['.xls', '.xlsx', '.csv']}
                                                addAttachmentBtnLabel={
                                                    attachments.length === 0 ? 'Vendor Contact Report File' : 'Vendor Summary Report File'
                                                }
                                                showRemoveBtn={false}
                                                saveAttachmentBase={INTEGRATION_CONSTANTS.QBD_BASE}
                                            />
                                        )}
                                        {isFileUploaded && (
                                            <p style={qbdStyles.uploadSuccessMessage}>Upload successful! Continue by clicking 'Next'.</p>
                                        )}
                                    </div>
                                </BasicCard>
                                {isFileUploaded && (
                                    <Button
                                        type={BUTTON_TYPE.PRIMARY}
                                        style={qbdStyles.nextButton}
                                        onClickCb={handleNextButtonClick}
                                    >
                                        Next
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Loadable>
                </>
            )}

        </>
    );
}